module.exports = {
  methods: {
    $_getTheme (isContinuity) {
      // 通常版とログアウト後
      if (!isContinuity) {
        return {
          primary: '#02AB98',
          secondary: '#ff6673',
          accent: '#CC0058',
          error: '#FF6E63',
          warning: '#FBC02D',
          info: '#63A7FF',
          success: '#1871A2',
          red: '#FF6E63',
          pink: '#E91E63',
          yellow: '#ffed66',
          orange: '#F49702',
          lightpink: '#ffe7e6',
          // blue: '',
          // green: '',
          // purple: '',
          gold: '#FBC02D',
          silver: '#90A4AE',
          bronze: '#8D6E63'
        }
      // 継続版
      } else {
        return {
          primary: '#F49702',
          secondary: '#ff6673',
          accent: '#CC0058',
          error: '#FF6E63',
          warning: '#FBC02D',
          info: '#63A7FF',
          success: '#1871A2',
          red: '#FF6E63',
          pink: '#E91E63',
          yellow: '#ffed66',
          orange: '#F49702',
          lightpink: '#ffe7e6',
          // blue: '',
          // green: '',
          // purple: '',
          gold: '#FBC02D',
          silver: '#90A4AE',
          bronze: '#8D6E63'
        }
      }
    }
  }
}
